(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rk-pack-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rk-pack-selector')) {
  customElements.define('rk-pack-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.form = this.querySelector('form');
      const requestedPack = new URLSearchParams(window.location.search).get('pack');
      const familyOption = this.querySelector('input[id$="-family"]');
      if (requestedPack === 'family' && familyOption) familyOption.checked = true;
      this.form.addEventListener('submit', async (event) => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return;
        event.preventDefault();
        if (this.busy) return;
        this.busy = true;
        const button = event.submitter;
        const error = this.querySelector('[role="alert"]');
        error.hidden = true;
        if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
        let added = false;
        try {
          const data = new FormData(this.form);
          const sections = typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map(section => section.id) : ['cart-drawer', 'cart-icon-bubble'];
          data.append('sections', sections.join(','));
          data.append('sections_url', window.location.pathname);
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);
          const response = await fetch(this.form.action + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || this.form.dataset.error);
          added = true;
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
        } catch (failure) {
          if (added) { window.location.assign(this.form.dataset.cartUrl); return; }
          error.textContent = failure.message || this.form.dataset.error;
          error.hidden = false;
        } finally {
          this.busy = false;
          if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
